<div class="chip" *ngrxLet="badge$ as badge" [ngClass]="badge.className">
    <dtm-ui-icon [name]="badge.iconName"></dtm-ui-icon>
    {{ badge.label | transloco }}
</div>
